export default {
    tokenAccess(state) { return state.tokens.access },
};
